import styled from "styled-components";

export const Input = styled.input`
  width: 280px;
  height: 45px;
  border-radius: 10px;
  border: 0;
  border: 1.5 px solid white;
  color: white;
  background-color: #343b41;
  padding-left: 10px;
  ::placeholder {
    font-family: "Inter";
    font-size: 15px;
  }
  &:focus-visible {
    border: none;
    outline: none;
    background-color: #343b41;
  }
`;

export const SelectInput = styled.select`
  width: 300px;
  height: 45px;
  border-radius: 10px;
  border: 0;
  border: 1.5 px solid white;
  color: white;
  background-color: #343b41;
  padding-left: 10px;
  ::placeholder {
    font-family: "Inter";
    font-size: 15px;
  }
`;
